import React from 'react';
import { useConfig } from '@/context/ConfigContext';
import './ConfigLoader.css';

interface ConfigLoaderProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const ConfigLoader: React.FC<ConfigLoaderProps> = ({ 
  children, 
  fallback 
}) => {
  const { isLoading, error } = useConfig();

  if (isLoading) {
    return (
      <div className="config-loader">
        {fallback || (
          <div className="config-loader-content">
            <div className="config-loader-spinner"></div>
            <p>Loading configuration...</p>
          </div>
        )}
      </div>
    );
  }

  if (error) {
    return (
      <div className="config-loader-error">
        <div className="config-loader-error-content">
          <h3>Configuration Error</h3>
          <p>{error}</p>
          <p>Using default configuration.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}; 